import { ITPP } from '../../../API/ApiManagementTypes';
import { CertificateType } from '../../../lib/constants';
import { Action, SIGNED_OUT_USER } from '../../actions/index';


const UPDATE_STEP = 'UPDATE_STEP';
const UPDATE_DETAILS = 'UPDATE_DETAILS';
const UPDATE_APIS = 'UPDATE_APIS';
const UPDATE_CREDENTIALS = 'UPDATE_CREDENTIALS';
const UPDATE_APPLICATION_TPP = 'UPDATE_APPLICATION_TPP'
const UPDATE_CERTIFICATE = 'UPDATE_CERTIFICATE';
const FLUSH_STATE = 'FLUSH_STATE';

export const CreateApplicationActions = {
    UPDATE_STEP,
    UPDATE_DETAILS,
    UPDATE_APIS,
    UPDATE_CREDENTIALS,
    UPDATE_APPLICATION_TPP,
    FLUSH_STATE
}
export interface APIRef {
    id: string,
    name: string
    certificateRequired: boolean,
    certificateRequiredType: CertificateType | null,
    sandboxEnabled: boolean,
    requiresOnlineBankingUser: boolean
}
export interface CreateApplicationState {
    step: number,
    certificateSkipped?: boolean
    details?: {
        name: string,
        description: string,
        redirectUris: string
    },
    tpp?: ITPP,
    APIS?: APIRef,
    credentials?: {
        APIKey: string,
        secret: string
    }
}

export const initialCreateApplicationState: CreateApplicationState = {
    step: 1,
    certificateSkipped: undefined,
    APIS: {
        id: '',
        name: '',
        certificateRequired: false,
        certificateRequiredType: null,
        sandboxEnabled: false,
        requiresOnlineBankingUser: false
    }

}

export const createApplicationReducer = (state = initialCreateApplicationState, action: Action) => {
    switch (action.type) {
        case UPDATE_STEP:
            return ({
                ...state,
                ...action.payload
            })
        case UPDATE_DETAILS:
            return ({
                ...state,
                details: { ...action.payload }
            })
        case UPDATE_APIS:
            return ({
                ...state,
                APIS: { ...action.payload }
            })
        case UPDATE_APPLICATION_TPP: {
            return ({
                ...state,
                tpp: { ...action.payload }

            })
        }
        case UPDATE_CREDENTIALS:
            return ({
                ...state,
                credentials: { ...action.payload }
            })
        case FLUSH_STATE: return initialCreateApplicationState //We don't want old state to persist when user has canceled or finished creating an application
        case SIGNED_OUT_USER:
            return initialCreateApplicationState
        default:
            return state
    }
}
